define('webshopProductsDetailBodyImagesTypeListImageView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'settings',
  'galleryView',
  'template!webshopProductsDetailBodyImagesTypeListImageView'
], function (
  App,
  Module,
  Backbone,
  Marionette,
  _,
  Settings,
  GalleryView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'image-view',

    ui: {
      imageContainer: '.image',
      zoomButton: '.zoom-button',
      deleteButton: '.delete-button',
      langSelect: '.lang-select'
    },

    events: {
      'click @ui.imageContainer': 'onClick',
      'click @ui.zoomButton': 'onZoom',
      'click @ui.deleteButton': 'onDelete',
      'change @ui.langSelect': 'onLangChange'
    },

    serializeData: function () {
      var data = {};

      var url = Settings.configValue('webshop.imagesUrl');
      data.src =  url + '/' + this.model.get('previewUrl');
      data.lang = this.model.get('lang') || '';
      data.languages = this.options.languages || [];
      // Keep a language set in the webshop selectable even if no site uses it anymore
      if (data.lang && !_.contains(data.languages, data.lang))
        data.languages = data.languages.concat([data.lang]);
      return data;
    },

    onLangChange: function () {
      var previous = this.model.get('lang') || '';
      var lang = this.ui.langSelect.val();

      this.options.product.updateImageLanguage(this.model.get('id'), lang).done(_.bind(function () {
        this.model.set('lang', lang || null);
      }, this)).fail(_.bind(function () {
        this.ui.langSelect.val(previous);
      }, this));
    },

    onDelete: function () {
      this.options.product.deleteImage(this.model.get('id')).done(_.bind(function () {
        this.trigger('item:deleted');
      }, this));
    },

    onZoom: function () {
      var urls = this.model.get('url');
      if(urls.length === 0)
        return;

      var url = Settings.configValue('webshop.imagesUrl') + '/' + this.model.get('url');

      GalleryView.prototype.open(
        'webshop.product.gallery.' + url,
        _.i18n('webshop.product.gallery.title') + ' | ' + url,
        new Backbone.Model({urls: [url]}));
    }
  });
});
